export enum ItemOriginType {
  PURCHASE = 'PURCHASE',
  PRODUCTION = 'PRODUCTION'
}
